import React, { useEffect } from "react";
import { Container, Grid, makeStyles, Paper } from "@material-ui/core";
import { LoginForm, RegistrationBox } from "./components";

import { Fragment } from "react";
import { Helmet } from "react-helmet";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    minHeight: "100vh",
    marginBottom: "0px",
    // backgroundSize: "cover",
    // backgroundImage: `url(${"/assets/images/bg6.jpeg"})`,
    backgroundColor: "#000",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // [theme.breakpoints.down('md')]:{
    //     width: '100%',
    //     minHeight: '100vh',
    //     alignItems:'start',
    //     display: 'flex',
    //     margin: '0'
    // }
  },
  paper: {
    [theme.breakpoints.down("md")]: {
      marginTop: "120px",
      marginBottom: "30px",
    },
  },
}));

function Login() {
  const classes = useStyles();
  const state = useSelector((state) => state.auth);
  const { currentUser } = useSelector((state) => state.auth);
  const history = useHistory();

  useEffect(() => {
    if (
      currentUser &&
      (currentUser.user || currentUser.author || currentUser.role == "member")
    ) {
      history.push("/");
    }
  }, []);

  return (
    <Fragment>
      <Helmet>
        <title>Login - d2p</title>
      </Helmet>
      <ToastContainer />
      <div className={classes.root}>
        <Container>
          <Paper className={classes.paper}>
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={12} md={6}>
                <LoginForm />
              </Grid>
              <Grid item xs={12} md={6}>
                <RegistrationBox />
              </Grid>
            </Grid>
          </Paper>
        </Container>
      </div>
    </Fragment>
  );
}

export default Login;
